import { useMemo } from 'react';

import { CampaignFrontendStatus } from 'store/models/campaignsDashboard';
import { useSelector } from 'store/utils';

interface CheckedCampaignIdsForBudgetResult {
    infiniteBudgetCampaignsCount: number;
    stoppedByEndDateCampaignsCount: number;
    campaignIdsForBudgetIncrease: Set<number>;
    campaignIdsForStop: Set<number>;
}

export const useCheckedCampaignIds = (): CheckedCampaignIdsForBudgetResult => {
    const checkedCampaignIds = useSelector((state) => state.campaignsDashboard.checkedCampaignIds);
    const campaigns = useSelector((state) => state.campaignsDashboard.campaigns);

    return useMemo(() => {
        let infiniteBudgetCampaignsCount = 0;
        let stoppedByEndDateCampaignsCount = 0;
        const campaignIdsForBudgetIncrease: Set<number> = new Set();
        const campaignIdsForStop: Set<number> = new Set();

        checkedCampaignIds.forEach((campaignId) => {
            const campaign = campaigns.get(campaignId);
            if (!campaign) {
                return;
            }

            const { frontendStatus, budget } = campaign;

            if (budget === null) {
                infiniteBudgetCampaignsCount += 1;
            } else if (frontendStatus === CampaignFrontendStatus.InactiveDueToEndDate) {
                stoppedByEndDateCampaignsCount += 1;
            } else {
                campaignIdsForBudgetIncrease.add(campaignId);
            }

            if (frontendStatus !== CampaignFrontendStatus.Blocked) {
                campaignIdsForStop.add(campaignId);
            }
        });

        return {
            infiniteBudgetCampaignsCount,
            stoppedByEndDateCampaignsCount,
            campaignIdsForBudgetIncrease,
            campaignIdsForStop,
        };
    }, [checkedCampaignIds, campaigns]);
};
